var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "max-width": "140px"
    },
    attrs: {
      "type": "number",
      "label": "Порог, дней",
      "dense": ""
    },
    on: {
      "change": _vm.fetch
    },
    model: {
      value: _vm.thresholdDays,
      callback: function ($$v) {
        _vm.thresholdDays = _vm._n($$v);
      },
      expression: "thresholdDays"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "green"
    },
    on: {
      "click": _vm.fetch
    }
  }, [_vm._v("Обновить")])], 1)], 1), _vm.loading ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "table-row@3"
    }
  })], 1)], 1) : _vm._e(), !_vm.loading ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "border-left": "thin solid rgba(255, 255, 255, 0.18) !important"
    }
  }, [_c('v-data-table', {
    staticClass: "table__lined",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "items-per-page": 20
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function (_ref) {
        var items = _ref.items;
        return [_c('tbody', _vm._l(items, function (item) {
          return _c('tr', {
            key: item.contractId
          }, [_c('td', [_c('router-link', {
            attrs: {
              "to": `/contracts/${item.contractId}/edit`
            }
          }, [_vm._v(" #" + _vm._s(item.contractNumber) + " ")])], 1), _c('td', [_vm._v(_vm._s(item.phaseText))]), _c('td', [_vm._v(_vm._s(item.lawyerName))]), _c('td', [_vm._v(_vm._s(item.clientName))]), _c('td', [_c('span', {
            class: item.isStuck ? 'red_link' : ''
          }, [_vm._v(" " + _vm._s(item.daysInPhase) + " ")])]), _c('td', [item.isStuck ? _c('span', {
            staticClass: "red_link"
          }, [_vm._v("⚠ застрял")]) : _vm._e()])]);
        }), 0)];
      }
    }], null, false, 2988528028)
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }